<template>
    <div style="background-color: #eeeeee;padding-bottom: 60px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner12.png" alt="">
        <div class="main" style="padding-bottom: 40px;">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">{{ $t("home") }}</li>
                <li>></li>
                <li>{{$t("joinUs")}}</li>
            </ul>
            <div class="joinUs">
                <div class="fleft">
                    <p>{{ $t("SocialRecruitment") }}</p>
                    <span @click="check(1, '社会招聘')" style="background-color: #268dcf;">{{ $t("ViewJobs") }}</span>
                </div>
                <div class="fleft">
                    <p>{{ $t("CampusRecruitment") }}</p>
                    <span @click="check(2, '校园招聘')" style="background-color: #cf6a26;">{{ $t("ViewJobs") }}</span>
                </div>
            </div>
        </div>
        <div style="background-color: #fff;padding: 30px 0;">
            <div style="width:900px;margin:0 auto;">
                <p style="font-size:16px;line-height: 36px;color: #222222;">
                    {{ $t("RecruitmentContents") }}
                </p>

            </div>
            <div style="width:1050px;margin:0 auto;">
                <div class="top" style="padding:0 160px">
                    <div>
                        <img src="../../assets/icon16.png" alt="">
                        <p>{{ $t("aboutustest11") }}</p>
                        <span>{{ $t("aboutustest12") }}</span>
                        <i>{{ $t("aboutustest13") }}<br />{{ $t("aboutustest14") }}</i>
                    </div>
                    <div>
                        <img src="../../assets/icon17.png" alt="">
                        <p>{{ $t("aboutustest21") }}</p>
                        <span>{{ $t("aboutustest22") }}</span>
                        <i>{{ $t("aboutustest23") }}<br />
                            {{ $t("aboutustest24") }}</i>
                    </div>
                </div>
                <div class="top">
                    <div>
                        <img src="../../assets/icon18.png" alt="">
                        <p>{{ $t("aboutustest31") }}</p>
                        <span>{{ $t("aboutustest32") }}</span>
                        <i>{{ $t("aboutustest33") }}<br />
                            {{ $t("aboutustest34") }}</i>
                    </div>
                    <div>
                        <img src="../../assets/icon19.png" alt="">
                        <p>{{ $t("aboutustest41") }}</p>
                        <span>{{ $t("aboutustest32") }}</span>
                        <i
                            style="text-align: left;padding: 0 30px;">{{ $t("aboutustest43") }}</i>
                    </div>
                    <div>
                        <img src="../../assets/icon20.png" alt="">
                        <p>{{ $t("aboutustest51") }}</p>
                        <span>{{ $t("aboutustest52") }}</span>
                        <i>{{ $t("aboutustest53") }}<br />
                            {{ $t("aboutustest54") }}</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="main" style="padding-top:60px">
            <img src="../../assets/banner13.png" alt="">
        </div>
    </div>
</template>
<script>
import {backPage} from '@/utils/common'

export default {
    methods: {
        check(id, type) {
            this.$router.push({ path: "/recruit", query: { id: id, type: type } })
            document.documentElement.scrollTop = 0;
        },
        backPage,

    }
}
</script>
<style scoped lang="scss">
.joinUs {
    height: 320px;
    background: url('../../assets/img27.png');
    overflow: hidden;
    padding: 90px 0;
    box-sizing: border-box;

    .fleft {
        width: 50%;
        text-align: center;
        color: #fff;

        >* {
            display: block;
        }

        p {
            font-size: 24px;
            font-weight: bold;
        }

        span {
            width: 100px;
            height: 36px;
            line-height:36px;
            font-size: 16px;
            font-family: 'MicrosoftYaHeiLight';
            margin: 20px auto;
            cursor: pointer;
        }

    }
}

.top {
    display: flex;

    >div {
        flex: 1;
        text-align: center;
        display: block;
        margin-bottom: 10px;

        img {
            display: block;
            margin: 20px auto;
        }

        p {
            font-size: 18px;
            color: #103f73;
            font-family: 'MicrosoftYaHeiLight';
        }

        span {
            font-size: 24px;
            color: #103f73;
            font-weight: bold;
            display: block;
            margin-bottom: 12px;
        }

        i {
            color: #222222;
            font-size: 14px;
            display: block;
            font-style: normal;
            line-height: 22px;
        }
    }
}</style>


// WEBPACK FOOTER //
// src/views/about/joinUs.vue